import { styled } from "styled-components";

import { colorsPalettes, setElevation } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

export const StyledWhiteTooltip = styled(Tooltip)`
    && {
        background-color: ${colorsPalettes.carbon[0]};
        color: ${colorsPalettes.carbon[400]};
        border-radius: 8px;
        ${setElevation("Z3")}
    }
`;

export const TooltipImage = styled.img`
    max-width: 240px;
    border-radius: 4px;
`;

export const StyledItalicText = styled(Text)`
    font-style: italic;
`;

export const StyledTooltipTrigger = styled(Flex)`
    cursor: help;
`;
